export default __webpack_public_path__ + "static/media/kerry2.26c94564.png";